<mat-sidenav-container class="sidenav-container">
  <!-- ── Dark sidebar panel ───────────── -->
  <mat-sidenav
    #drawer
    [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
    [mode]="(isHandset$ | async) ? 'over' : 'side'"
    [opened]="(isHandset$ | async) === false"
    class="sidenav"
    fixedInViewport>
    <app-staff-sidebar
      [moduleIconTitle]="moduleIconTitle"
      [moduleIconType]="moduleIconType"
      [moduleTitle]="moduleTitle"
      [sidebarMenu]="moduleMenu">
    </app-staff-sidebar>
  </mat-sidenav>

  <!-- ── Main content area ─────────────── -->
  <mat-sidenav-content class="main-content">

    <!-- ══ TOP TOOLBAR ══════════════════════════════════════ -->
    <header class="topbar">
      <div class="topbar__left">
        <!-- Mobile hamburger -->
        @if (isHandset$ | async) {
          <button class="topbar__hamburger" (click)="drawer.toggle()" type="button" aria-label="Toggle menu">
            <mat-icon>menu</mat-icon>
          </button>
        }

        <!-- Back to dashboard button (Internal users) -->
        @if (userType == 'Internal') {
          <button class="topbar__back-btn" (click)="goBack()" [matTooltip]="'Go to dashboard' | translate">
            <mat-icon>home</mat-icon>
          </button>
        }

        <!-- Breadcrumb / Page title area -->
        <div class="topbar__breadcrumb">
          <span class="topbar__breadcrumb-dot"></span>
          <span class="topbar__breadcrumb-label">{{ (moduleTitle || 'Dashboard') | translate }}</span>
        </div>
      </div>

      <div class="topbar__right">
        <app-main-toolbar></app-main-toolbar>
      </div>
    </header>

    <!-- Route transition indicator: gives immediate feedback the moment a
         sidebar link is clicked, even while the target module's lazy chunk
         is still downloading (a slow-network gap that otherwise looks like
         the click did nothing). -->
    @if (navigating) {
      <mat-progress-bar mode="indeterminate" class="route-progress-bar"></mat-progress-bar>
    }

    <!-- ══ PAGE CONTENT ═════════════════════════════════════ -->
    <div class="page-wrapper">
      <router-outlet></router-outlet>
    </div>

    <!-- Chat Widget -->
    <app-chat-widget></app-chat-widget>

  </mat-sidenav-content>
</mat-sidenav-container>
